module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/cookie-08ff47778a24863cbcb94ccbd561862b.svg";